<template>
  <div class="overflow-auto">
    <b-container fluid class="bv-example-row">
      <b-modal
        id="bv-modal-create-new-organisation"
        header-bg-variant="dark"
        header-text-variant="light"
        body-bg-variant="dark"
        body-text-variant="light"
        hide-footer
        @hide="guardModalClose($event, 'createNew')"
      >
        <template v-slot:modal-title>
          {{$t('organisation.create.title')}}
        </template>
        <Create @onCreated="closeCreate" ref="createNew"></Create>
      </b-modal>
      <b-modal
        id="bv-modal-edit-organisation"
        header-bg-variant="dark"
        header-text-variant="light"
        body-bg-variant="dark"
        body-text-variant="light"
        hide-footer
        @hide="guardModalClose($event, 'edit')"
      >
        <template v-slot:modal-title>
          {{$t('organisation.update.title')}}
        </template>
        <Edit @onUpdated="closeEdit" :id=organisationEditId ref="edit"></Edit>
      </b-modal>
      <b-row>
        <b-col md="3">
          <b-button block variant="primary" @click="openCreate">{{$t('create_organisation')}}</b-button>
        </b-col>
          <b-col md="2">
          <span class="text-nowrap">
                        {{$t('organisation_selected')+ ': ' + rows}}
                    </span>
          </b-col>
        <b-col md="4" offset-md="2">
          <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-container>
    <b-table
        v-if="!tableIsBusy"
        dark
             ref="organisationListTable"
             id="my-table"
             :items="myProvider"
             :per-page="perPage"
             :current-page="currentPage"
             :hover="hover"
             head-variant="dark"
             small
             :fields="fields"
             no-local-sorting
             :filter="filterListTable"
             :filterIncludedFields="filterOn"
             stacked="md"
             :filter-function="onFilter"
             striped
    >
      <template v-slot:head()="scope">
        <div class="text-nowrap">
            {{scope.label}}
        </div>
      </template>

      <template v-slot:cell(selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template>
      <template v-slot:cell(settings)="row">
<!--        <router-link :to="{ name: 'editorganisation', params: { id: row.item.id }}" ><b-icon-tools></b-icon-tools></router-link>-->
        <b-icon-tools v-on:click="openEdit(row)"></b-icon-tools>

      </template>
      <template v-slot:cell(isDefault)="row">
        <b-form-checkbox v-model="row.item.isDefault" disabled></b-form-checkbox>
      </template>
      <template v-slot:cell(isActive)="row">
        <b-form-checkbox v-model="row.item.isActive" disabled></b-form-checkbox>
      </template>
      <template slot="thead-top" slot-scope="{ fields }">
        <td v-for="field in fields" :key="field.key">
          <b-input
              v-if="field.filtered === true"
              v-model="filters[field.key]"
              :placeholder="field.label"
          />
        </td>
      </template>
    </b-table>
  </div>
</template>

<script>
import axios from "axios";

import Create from "./Create";
import Edit from "./Edit";

export default {
  name: "OrganisationList",
  components: {
    Create,
    Edit
  },
  data() {
    return {
        tableIsBusy: true,
      filter: null,
      filterOn: [],
      isBusy: true,
      perPage: Math.floor(document.documentElement.clientHeight/44),
      currentPage: 1,
      rows: 0,
      organisationEditId: undefined,
      fields: [
        {
          key: 'settings',
          label: 'organisation_list.coll.header.settings',
          sortable: false,
          stickyColumn: true
        },
        {
          key: 'type',
          label: 'organisation_list.coll.header.type',
          sortable: true,
        },
        {
          key: 'name',
          label: 'organisation_list.coll.header.name',
          sortable: true,
          size: 150,
          filtered: true
        },
        {
          key: 'identity',
          label: 'organisation_list.coll.header.identity',
          sortable: true,
            size: 150,
            filtered: true
        },
        {
          key: 'parent',
          label: 'organisation_list.coll.header.creator',
          sortable: true,
          size: 150,
          filtered: true
        },
        {
          key: 'devices',
          label: 'organisation_list.coll.header.devices',
          sortable: true,
        },
        {
          key: 'isActive',
          label: 'organisation_list.coll.header.isActive',
          sortable: true,
        },
        {
          key: 'regDate',
          label: 'organisation_list.coll.header.regDate',
          sortable: true,
        },
      ],
      // items: [ ],
      small: true,
      bordered: true,
      hover: true,
        delayTimer: 0,
      filters: {
        name: null,
        identity: null,
        parent: null,
      },
        filterListTable: {
            name: null,
            identity: null,
            parent: null,
      },
      breadcrumb: [
        {
          text: 'Admin',
          href: '#'
        },
        {
          text: 'Manage',
          href: '#'
        },
        {
          text: 'Library',
          active: true
        }
      ],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: ''
      }
    }
  },
  computed: {
    // rows() {
    //     return this.items.length
    // }
  },
  methods: {
    guardModalClose(event, ref) {
      const form = this.$refs[ref];
      if (form?.saving && !(form.created || form.updated)) event.preventDefault();
    },
    openCreate() {
      this.$bvModal.show('bv-modal-create-new-organisation')
    },
    closeCreate() {
      this.refreshTable();
      this.$bvModal.hide('bv-modal-create-new-organisation')
    },
    openEdit(row) {
      this.organisationEditId = row.item.id;
      this.$bvModal.show('bv-modal-edit-organisation')
    },
    closeEdit() {
      this.refreshTable();
      this.$bvModal.hide('bv-modal-edit-organisation')
    },
    onFilter: function() {
      // alert(11);
      // console.log('onFilter');
    },
    onRowSelected(items) {
      this.selected = items
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    onFiltered(filteredItems) {
      // console.log(this.filters)
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    refreshTable() {
      if (this.$refs.organisationListTable !== undefined) {
        this.$refs.organisationListTable.refresh();
      }
    },
    myProvider (ctx) {
      // console.log(ctx)
      // Here we don't set isBusy prop, so busy state will be
      // handled by table itself
      let params = '?page='
          + ctx.currentPage
          + '&rows=' + ctx.perPage
          + '&sortBy=' + (ctx.sortBy === '' ? 'id' : ctx.sortBy)
          + '&sortOrder=' + (ctx.sortBy === '' ? 'desc' : ctx.sortDesc ? 'desc': 'asc')

      for (let field in this.filters) {
        if (this.filters[field] !== null) {
          params += "&" + field + "=" +  this.filters[field];
        }
      }

      this.isBusy = true
      let promise = axios.get('api/v1/organisations' + params)

      return promise.then((data) => {
        const items = data.data.data
        // Here we could override the busy state, setting isBusy to false
        this.rows = data.data.records
        this.isBusy = false

        return(items)
      }).catch(() => {
        // Here we could override the busy state, setting isBusy to false
        // this.isBusy = false
        // Returning an empty array, allows table to correctly handle
        // internal busy state in case of error
        // console.log(error)
        return []
      })
    },
      updateFields() {

          this.fields.forEach(
              column => {
                  column.label = this.$t(column.label)
              }
          )

      },
      setTableFilter: function() {
          for (let field in this.filters) {
              this.filterListTable[field] = this.filters[field]
          }
      },

  },
    watch: {
        filters: {
            handler(){
                clearTimeout(this.delayTimer);

                this.delayTimer = setTimeout(this.setTableFilter, 2000);

            },
            deep: true
        }
    },
  mounted() {
      this.updateFields();

      this.tableIsBusy = false;
  }
}
</script>

<style scoped>

</style>